export const MIN_SCORE = 3
